import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PromoterPayoutListLayer from "../../components/PromoterPayout/PromoterPayoutListLayer";

const PromoterPayoutList = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Promoter Payout Management" />
      <PromoterPayoutListLayer />
    </MasterLayout>
  );
};

export default PromoterPayoutList;
